"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("@folio/stripes/components");
var _CycleButton = _interopRequireDefault(require("../../../styles/CycleButton.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CycleButton = _ref => {
  let {
    buttons,
    startIndex = 0
  } = _ref;
  const [index, setIndex] = (0, _react.useState)(startIndex);
  const {
    className,
    onClick,
    ...buttonProps
  } = buttons[index];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
    ...buttonProps,
    className: (0, _classnames.default)(className, _CycleButton.default.buttonStyle),
    onClick: e => {
      if (onClick) {
        onClick(e);
      }
      setIndex(index !== buttons?.length - 1 ? index + 1 : 0);
    }
  });
};
CycleButton.propTypes = {
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    className: _propTypes.default.object,
    icon: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })),
  startIndex: _propTypes.default.number
};
var _default = exports.default = CycleButton;